var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.parentID == '0')?_c('p',[_vm._v(_vm._s(_vm.getScriptNameByID(_vm.sourceId)))]):_vm._e(),_c('ul',_vm._l((_vm.node),function(item,index){return _c('scriptItem',{key:index,attrs:{"sourceId":_vm.sourceId,"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }